export default {
    ARRAY: "array",
    STRING: "string",
    BOOLEAN: "boolean",
    INTEGER: "integer",
};
